import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../styles/constants.style";

export const CPParticipantsResultsWrapper = styled.div`
  margin: 19px 0px 39px;

  ${responsive.MOBILE`
    margin: 0;
  `}

  .form-header {
    display: flex;
    align-items: center;
    background-color: ${COLORS.primary_light_blue2};
    padding: 10px 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .participant-name-link {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .cell-assigned-coaches {
    display: flex;
    justify-content: center;
  }

  .MuiChip-label {
    align-items: center;
  }
`;
